import isEqual from 'lodash/isEqual'
import productAPI from '../../api/Products'
import * as types from '../mutation-types'

// STATE
const state = {
    ProductSuggestions: [],
    Product : [],
    Products: [],
    ProductFilters: [],
    ProductPagination: {},
    FastOrderProducts: [],
    ProductAccessRequested: ''
}

// GETTERS
const getters = {
    productsByTerm: state => state.ProductSuggestions,
    Product: state => state.Product,
    Products: state => state.Products,
    ProductFilters: state => state.ProductFilters,
    ProductPagination: state => state.ProductPagination,
    FastOrderProducts: state => state.FastOrderProducts,
    ProductAccessRequested: state => state.ProductAccessRequested
}

// ACTIONS
const actions = {
    /// PRODUCT ACCESS REQUEST
    setProductAccessRequested ({ commit }, name) {
        commit(types.SET_PRODUCT_ACCESS_REQUESTED, name);
    },
    clearProductAccessRequested ({ commit }) {
        commit(types.CLEAR_PRODUCT_ACCESS_REQUESTED);
    },

    /// PRODUCT LIST
    getProducts ({ commit }, params){
        return new Promise((resolve) => {
            productAPI.getProducts(response => {
                commit(types.RECEIVE_PRODUCTS, { response })
                resolve()
            }, params)
        })
    },

    getProductById({commit}, params){
        return new Promise((resolve) => {
            productAPI.getProduct(response => {
                commit(types.RECEIVE_PRODUCT_BY_ID, { response })
                resolve(response)
            }, params)
        })
    },

    getProductsByTerm ({ commit }, params) {
        return new Promise((resolve) => {
            productAPI.getProductsAutocomplete(response => {
                commit(types.RECEIVE_SEARCH_PRODUCTS, { response })
                resolve(response)
            }, params)
        })
    },

    getProductAggregations({commit}, params){
        return new Promise((resolve) => {
            productAPI.getProductAggregations(response => {
                commit(types.RECEIVE_AGGREGATIONS, {response})
                resolve(response)
            }, params)
        })
    },

    getFastOrderProduct({commit, state}, id){
        return new Promise((resolve, reject) => {
            productAPI.getFastOrderProduct(response => {
                // Check for duplicate products
                let hasDuplicate = state.FastOrderProducts.some((product) => {
                    return isEqual(product, response);
                });

                if (hasDuplicate) {
                    reject(response)
                } else {
                    commit(types.RECEIVE_FAST_ORDER_PRODUCT, { response })
                    resolve(response)
                }
            }, id)
        })
    },

    deleteFastOrderProduct({commit, state}, product){
        return new Promise((resolve) => {
            commit(types.REMOVE_FAST_ORDER_PRODUCT, { product })
            resolve(product)
        })
    },
    deleteFastOrderProducts({commit}){
        return new Promise((resolve) => {
            commit(types.REMOVE_FAST_ORDER_PRODUCTS)
            resolve()
        })
    },

    deleteFastOrderProductSizes({commit, state}, product){
        return new Promise((resolve) => {
            commit(types.REMOVE_FAST_ORDER_PRODUCT_SIZES, { product })
            resolve(product)
        })
    }


}

// mutations
const mutations = {
    [types.RECEIVE_PRODUCTS] (state, { response }){
        state.Products = response.Products;
        state.ProductFilters = response.Filters;
        state.ProductPagination = {
            PageFirstIndex: response.PageFirstIndex,
            PageLastIndex: response.PageLastIndex,
            PageStartIndex: response.PageStartIndex,
            PageEndIndex: response.PageEndIndex,
            Pages : response.Pages,
            TotalCount: response.Totalcount
        }
    },

    [types.RECEIVE_PRODUCT_BY_ID] (state, { response }){
        state.Product = response.Product;
    },

    [types.RECEIVE_AGGREGATIONS] (state, {response}){
        state.ProductFilters = response.Filters
    },

    [types.RECEIVE_SEARCH_PRODUCTS] (state, { response }) {
        state.ProductSuggestions = response
    },

    [types.RECEIVE_FAST_ORDER_PRODUCT] (state, { response }) {
        state.FastOrderProducts.unshift(response)
    },

    [types.REMOVE_FAST_ORDER_PRODUCT] (state, { product }) {
        state.FastOrderProducts.splice(state.FastOrderProducts.map(item => item.Id).indexOf(product.Id), 1);
    },

    [types.REMOVE_FAST_ORDER_PRODUCTS] (state) {
        state.FastOrderProducts = []
    },

    [types.REMOVE_FAST_ORDER_PRODUCT_SIZES] (state, { product }) {
        state.FastOrderProducts.forEach((item) => {
            if (isEqual(item, product)) {
                item.Variants.forEach((variantline) => {
                    variantline.forEach((variant) => {
                        variant.Amount = null;
                    });
                });
            }
        });
    },

    [types.SET_PRODUCT_ACCESS_REQUESTED] (state, name) {
        state.ProductAccessRequested = name
    },
    [types.CLEAR_PRODUCT_ACCESS_REQUESTED] (state) {
        state.ProductAccessRequested = ''
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/Products.js